import axios from "axios";
import { API_BASE_URL } from "@/lib/apiBase";

export async function listSocialSavedPosts(
  token,
  { limit = 20, offset = 0 } = {}
) {
  const { data } = await axios.get(`${API_BASE_URL}/social/saved-posts`, {
    headers: { Authorization: `Bearer ${token}` },
    params: { limit, offset },
  });
  return data || { posts: [], total: 0 };
}

export async function getSocialSavedPostsStatus(token, postIds = []) {
  const ids = [...new Set((postIds || []).map(String).filter(Boolean))];
  if (!ids.length) return { saved: {} };
  const { data } = await axios.get(
    `${API_BASE_URL}/social/saved-posts/status`,
    {
      headers: { Authorization: `Bearer ${token}` },
      params: { post_ids: ids.join(",") },
    }
  );
  return data || { saved: {} };
}

export async function saveSocialPost(token, postId) {
  const { data } = await axios.put(
    `${API_BASE_URL}/social/saved-posts/${postId}`,
    null,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return data;
}

export async function unsaveSocialPost(token, postId) {
  const { data } = await axios.delete(
    `${API_BASE_URL}/social/saved-posts/${postId}`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return data;
}
